import * as React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

const SEO = ({ description, lang, meta, title }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `,
  );

  const metaDescription = description || site.siteMetadata.description;
  const defaultTitle = site.siteMetadata?.title;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:image',
          content: 'https://ftx-rp.netlify.app/img/meta-image.png',
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:creator',
          content: site.siteMetadata?.author || '',
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: metaDescription,
        },
      ].concat(meta)}>
      <script type="application/ld+json" async>
        {`
{
  "@context": "https://schema.org",
  "@type": "Event",
  "name": "Razorpay FTX 2021",
  "description": "A virtual fintech conference for disruptors",
  "startDate": "2021-12-09T10:00+05:30",
  "endDate": "2021-12-10T19:00+05:30",
  "eventStatus": "https://schema.org/EventMovedOnline",
  "eventAttendanceMode": "https://schema.org/OnlineEventAttendanceMode",
  "location": {
    "@type": "VirtualLocation",
    "url": "https://razorpay.com/ftx/"
  },
  "offers": [{
    "@type": "Offer",
    "name": "Silver",
    "price": "99",
    "priceCurrency": "INR",
    "validFrom": "2021-10-26",
    "url": "",
    "availability": "https://schema.org/InStock"
  },{
    "@type": "Offer",
    "name": "Gold",
    "price": "999",
    "priceCurrency": "INR",
    "validFrom": "2021-10-26",
    "url": "",
    "availability": ""
  },{
    "@type": "Offer",
    "name": "Platinum",
    "price": "9999",
    "priceCurrency": "INR",
    "validFrom": "2021-10-26",
    "url": "",
    "availability": ""
  }]
}
    `}
      </script>
    </Helmet>
  );
};

SEO.defaultProps = {
  lang: 'en',
  meta: [],
  description: '',
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default SEO;
